import { Directive, HostListener, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[jniNumberOnly]",
})
export class NumberOnlyDirective {
  private _oldvalue = "";
  private regExpr = new RegExp("^[0-9]*$");
  
  constructor(@Optional() private control: NgControl) {}

  @HostListener("input", ["$event"])
  change($event: Event) {
    const item = $event.target as HTMLInputElement;
    const value = item.value;
    let pos = item.selectionStart ?? 0;
    const matchvalue = value;
    const noMatch: boolean = !this.regExpr.test(matchvalue) && value !== "";
    
    if (noMatch) {
      item.selectionStart = item.selectionEnd = pos - 1;
      if (item.value.length < this._oldvalue.length && pos == 0) pos = 2;
      if (this.control)
        this.control?.control?.setValue(this._oldvalue, { emit: false });

      item.value = this._oldvalue;
      item.selectionStart = item.selectionEnd = pos - 1;
    } else {
      this._oldvalue = value;
    }
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    
    // Allow: backspace, delete, tab, escape, enter
    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "Tab" ||
      key === "Escape" ||
      key === "Enter"
    ) {
      return;
    }
    
    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (
      (event.ctrlKey || event.metaKey) &&
      (key === "a" || key === "c" || key === "v" || key === "x")
    ) {
      return;
    }
    
    // Allow: home, end, left, right
    if (
      key === "Home" ||
      key === "End" ||
      key === "ArrowLeft" ||
      key === "ArrowRight"
    ) {
      return;
    }
    
    // Ensure that it is a number and stop the keypress if it's not
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  @HostListener("paste", ["$event"])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string = event.clipboardData?.getData("text/plain") ?? "";
    
    // Only allow numbers (including leading zeros)
    if (/^[0-9]*$/.test(pastedInput)) {
      const item = event.target as HTMLInputElement;
      const start = item.selectionStart ?? 0;
      const end = item.selectionEnd ?? 0;
      const currentValue = item.value;
      const newValue = currentValue.slice(0, start) + pastedInput + currentValue.slice(end);
      
      if (this.control) {
        this.control?.control?.setValue(newValue, { emit: true });
      } else {
        item.value = newValue;
      }
      
      // Set cursor position after pasted content
      const newPosition = start + pastedInput.length;
      item.setSelectionRange(newPosition, newPosition);
    }
  }
}
